import {
  CampaignUpdatedEvent,
  RexListingCreatedEvent,
} from 'types/pushNotifications'

export const handleCampaignUpdated = async (
  event: CampaignUpdatedEvent,
  invalidateCampaignScopedQueries: (campaignId: string) => Promise<void>,
  invalidateSelectedCampaign: (campaignId: string) => Promise<void>,
  invalidateQueriesByAgencyId: ((agencyId: string) => Promise<void>)[]
) => {
  if (!event.agencyId) return
  if (!event.campaignId) return

  await Promise.all([
    invalidateCampaignScopedQueries(event.campaignId),
    invalidateSelectedCampaign(event.campaignId),
    ...invalidateQueriesByAgencyId.map((fn) => fn(event.agencyId)),
  ])
}

export const handleRexListingCreated = async (
  event: RexListingCreatedEvent,
  invalidateCampaignListing: (campaignId: string) => Promise<void>
) => {
  if (!event.campaignId) return

  await invalidateCampaignListing(event.campaignId)
}
